import { PASSWORD_RESET_REQUEST } from './authConfig';
import { redirectToUrl } from './components/VenuePage/conditionCheck';
import { handleTokenResponse } from './components/VenuePage/conditionCheck';

const AuthRedirect = msalInstance => {
  // Handle the redirect flows
  if (!localStorage['msal.idtoken']) {
    msalInstance
      .handleRedirectPromise()
      .then(handleTokenResponse)
      .catch(error => {
        if (error) {
          // Handle redirect error
          localStorage.setItem('error', error);
          let errorInLocal = localStorage.getItem('error');
          if (errorInLocal.indexOf('AADB2C90118') > -1) {
            redirectIfForgotPassword();
          }
          if (errorInLocal.indexOf('AADB2C90091') > -1) {
            redirectToUrl();
          }
        }
      });
  }

  const redirectIfForgotPassword = () => {
    localStorage.removeItem('error');
    msalInstance.loginRedirect(PASSWORD_RESET_REQUEST);
  };
};

export default AuthRedirect;
